import Pie from '../../components/Incidents/charts/Pie';

const processData = (typesData = {}) => {
  return Object.entries(typesData).map(([key, value]) => ({
    label: key === '' ? 'Not set' : key,
    value: value,
  })).sort((a, b) =>   b.value - a.value);
};

const IncidentTypeDistributionChart = ({ data }) => {
  const pieData = processData(data);
  return <Pie data={pieData} />;
};

export default IncidentTypeDistributionChart;
